export const FETCH_SFV_VISITS = "[GROUP_ADMIN] FETCH_SFV_VISITS";
export const FETCH_SFV_VISITS_START = "[GROUP_ADMIN] FETCH_SFV_VISITS_START";
export const FETCH_SFV_VISITS_SUCCESS = "[GROUP_ADMIN] FETCH_SFV_VISITS_SUCCESS";
export const FETCH_SFV_VISITS_ERROR = "[GROUP_ADMIN] FETCH_SFV_VISITS_ERROR";
export const SET_SFV_VISITS_PAGINATION = "[GROUP_ADMIN] SET_SFV_VISITS_PAGINATION";

export const fetchSubmittedForVerificationVisits = (data) => {
    return {
        type: FETCH_SFV_VISITS,
        payload: data
    }
}